// @flow

import { type UserInputValidationError, VALID } from '@tectonics/prs/validation';

export function validatePeruvianAddress(addressValue: string): ?UserInputValidationError {
  return addressValue ? VALID : { id: 'empty' };
}
